/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fullscreen'
export default icon
